module.exports = __webpack_public_path__ + "static/img/shenpi1.b31df17c.png";